import { render, staticRenderFns } from "./DataLayer.vue?vue&type=template&id=3bbeefda&"
import script from "./DataLayer.vue?vue&type=script&lang=ts&"
export * from "./DataLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports